import { ApiError } from "../types/types";
import { t } from "@preppa/translation";

export const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export async function parseApiError(response: Response): Promise<ApiError> {
  try {
    const body = await response.json();
    if (body && typeof body.status === "number" && typeof body.error === "string" && typeof body.message === "string") {
      return body as ApiError;
    }
  } catch {
    // Response body was not valid JSON
  }
  return {
    status: response.status,
    error: response.statusText || t("errors.unknownError"),
    message: t("errors.requestFailed", { status: response.status }),
  };
}
